import { useEffect, useState } from 'react';

type CameraState = 'checking' | 'available' | 'unavailable';

export function useCameraAvailable(): CameraState {
  const [state, setState] = useState<CameraState>('checking');

  useEffect(() => {
    const check = async () => {
      if (!navigator.mediaDevices?.enumerateDevices) {
        setState('unavailable');
        return;
      }

      let hasCamera = false;

      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        hasCamera = devices.some(d => d.kind === 'videoinput');
      } catch {
        setState('unavailable');
        return;
      }

      setState(hasCamera ? 'available' : 'unavailable');
    };

    check();
  }, []);

  return state;
}
